import { Builder } from "@builder.io/react";
import { registerMenuGroups, commonInputs } from "./helper";
import { Section, Article, ContactPageContent, ContactUsPageSection } from "@/components/Sections";

const sectionComponents = [
  {
    name: "Sections",
    items: [
      { name: "Section" },
      { name: "Article" },
      { name: "ContactPageContent" },
      { name: "ContactUsPageSection" },
    ]
  },
];

export const registerSectionComponents = () => {
  registerMenuGroups(sectionComponents);

  // Sections Components
  Builder.registerComponent(Section, {
    name: 'Section',
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "useContainer",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "hasShapeBackground",
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: "content",
        type: 'uiBlocks',
        defaultValue: [],
      },
      {
        name: "columnCount",
        type: "enum",
        enum: [
          { label: "Single Column", value: "1" },
          { label: "Two Columns", value: "2" },
          { label: "Three Columns", value: "3" }
        ],
        defaultValue: "1",
        helperText: "Choose the number of columns for this section"
      },
      {
        name: "columnGap",
        type: "enum",
        enum: [
          { label: "Small", value: "small" },
          { label: "Medium", value: "medium" },
          { label: "Large", value: "large" }
        ],
        defaultValue: "medium",
        showIf: `options.get('columnCount') !== '1'`,
        helperText: "Choose the gap between columns"
      },
      {
        name: "column1Content",
        type: 'uiBlocks',
        showIf: `options.get('columnCount') !== '1'`,
        defaultValue: [],
        helperText: "Content for the first column"
      },
      {
        name: "column2Content",
        type: 'uiBlocks',
        showIf: `options.get('columnCount') === '2' || options.get('columnCount') === '3'`,
        defaultValue: [],
        helperText: "Content for the second column"
      },
      {
        name: "column3Content",
        type: 'uiBlocks',
        showIf: `options.get('columnCount') === '3'`,
        defaultValue: [],
        helperText: "Content for the third column"
      },
    ],
  });

  Builder.registerComponent(Article, {
    name: 'Article',
    noWrap: true,
    canHaveChildren: false,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "withLeftColumn",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "leftColumn",
        type: 'uiBlocks',
        showIf: `options.get('withLeftPanel') === true`,
        defaultValue: [],
      },
      {
        name: "withRightColumn",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "showIndexBlock",
        type: "boolean",
        helperText: "Index block will be shown in the right column",
        showIf: `options.get('withRightColumn') === true`,
        defaultValue: true,
      },
      {
        name: "rightColumn",
        type: 'uiBlocks',
        showIf: `options.get('withRightColumn') === true`,
        defaultValue: [],
      },
      {
        name: "content",
        type: 'uiBlocks',
        defaultValue: [],
      },
    ],
    
  });

  Builder.registerComponent(ContactPageContent, {

    name: 'ContactPageContent',
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: false,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "listContent",
        type: 'list',
        defaultValue: [
          
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(ContactUsPageSection, {
    name: 'ContactUsPageSection',
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "useContainer",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "hasShapeBackground",
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: "leftColumnContent",
        type: 'uiBlocks',
        defaultValue: [],
        helperText: "Content for the left column"
      },
      {
        name: "rightColumnContent",
        type: 'uiBlocks',
        defaultValue: [],
        helperText: "Content for the right column"
      },
    ],
  });
};

